const jquery = $;

jquery(document).ready(() => {
  jquery('#app-product-taxonomy-tree').choiceTree('productTaxon', true, 9);

  jquery('.link.ui.dropdown')
    .on('contextmenu', function (event) {
      event.preventDefault();

      $(this).blur();
      $(this).find('[data-modal-open]').first().click();
    });
});
